import { connect } from 'react-redux'
import { compose, withHandlers, withProps, lifecycle, withState, withStateHandlers } from 'recompose'
import { bindActionCreators } from 'redux'


import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'


import SignatureEnable from './component'


const mapStateToProps = state => ({
  draft: PlaybookSelectors.draft(state),
  isActive: PlaybookSelectors.isEnabled(state),
})


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      //someAction: PlaybookActions.someAction,
    },
    dispatch
  ),
})


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      // TODO: something
    },
  }),
  withState('isLoading', 'setIsLoading', false),
  withHandlers({
    onChange: props => (arg) => {
      const { orgId } = props
      // TODO: do some action here
    },
  }),
)(SignatureEnable)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SignatureEnable/index.js